import { LockClosedIcon } from "@heroicons/react/20/solid"

/** Why a setup step is read-only: a financing lock or a fixed value. */
export const LockedNote = ({
  children,
  testId,
}: {
  children: string
  testId?: string
}): JSX.Element => (
  <p
    role="note"
    data-testid={testId}
    className="flex items-start gap-2 text-[length:var(--step--2)] text-muted"
  >
    <LockClosedIcon aria-hidden="true" className="mt-0.5 size-4 shrink-0" />
    {children}
  </p>
)
